import React from 'react'
import moment from 'moment'
import { Col, Divider } from 'antd'

import currencyMask from 'src/components/Formik/InputCurrency/mask'
import { Modal, Button, Text } from 'src/components/Ant'
import { RequestTicket } from 'src/types'
import { stringify } from 'src/core/hooks/use-translation'

import ThumbnailList from '../ThumbnailList'
import { WrapRow } from './styles'

interface Props {
  receipt: RequestTicket
  toggle(): void
  visible: boolean
}

function ModalVisualization({ receipt, toggle, visible }: Props) {
  return (
    <Modal
      destroyOnClose
      footer={[
        <Button key="submit" onClick={toggle} title="common.actions.cancel" />
      ]}
      onCancel={() => toggle()}
      title={
        receipt &&
        stringify('web.receipts.title-id', {
          number: receipt.request_ticket_number
        })
      }
      visible={visible}
      width={720}
    >
      {!!receipt && (
        <>
          <WrapRow gutter={24}>
            <Col span={12}>
              <Text colon strong title="web.receipt.form.owner">
                {receipt.request_ticket_user_data[0].traveler.name}
              </Text>
            </Col>
            <Col span={12}>
              <Text colon strong title="web.receipt.form.date.title">
                {moment
                  .unix(receipt.request_ticket_receipts[0].date)
                  .format('DD MMMM YYYY')}
              </Text>
            </Col>
          </WrapRow>
          <WrapRow gutter={24}>
            {receipt.request_ticket_receipts[0].service.service_type ===
              'QUANTITY' && (
              <Col span={24}>
                <Text colon strong title="web.receipt.form.quantity.title">
                  {receipt.request_ticket_receipts[0].quantity}
                </Text>
              </Col>
            )}
            {receipt.request_ticket_receipts[0].service.service_type ===
              'VALUE' && (
              <>
                <Col span={8}>
                  <Text
                    colon
                    strong
                    title="web.services.advances.form.currency.title"
                  >
                    {receipt.request_ticket_receipts[0].currency.code}
                  </Text>
                </Col>
                <Col span={8}>
                  <Text
                    colon
                    strong
                    title="web.services.advances.form.amount.title"
                  >
                    {
                      currencyMask({
                        formatStr: true,
                        value: receipt.request_ticket_receipts[0].amount
                      }).maskedValue
                    }
                  </Text>
                </Col>
                {receipt.request_ticket_receipts[0].currency.code !== 'BRL' && (
                  <Col span={8}>
                    <Text
                      colon
                      strong
                      title="web.services.advances.form.exchange-rate.title"
                    >
                      {
                        currencyMask({
                          formatStr: true,
                          precision: 4,
                          value:
                            receipt.request_ticket_receipts[0].exchange_rate
                        }).maskedValue
                      }
                    </Text>
                  </Col>
                )}
              </>
            )}
          </WrapRow>
          <WrapRow gutter={24}>
            <Col span={8}>
              <Text colon strong title="web.receipt.form.service.title">
                {receipt.request_ticket_receipts[0].service.name}
              </Text>
            </Col>
            <Col span={8}>
              <Text colon strong title="web.receipt.form.reference.title">
                {receipt.request_ticket_receipts[0].reference.name}
              </Text>
            </Col>
            <Col span={8}>
              <Text
                colon
                strong
                title="web.receipt.form.payment-resource.title"
              >
                {receipt.request_ticket_receipts[0].payment_resource.name}
              </Text>
            </Col>
          </WrapRow>
          <WrapRow gutter={24}>
            <Col span={12}>
              <Text colon strong title="web.receipt.form.invoice.title">
                {receipt.request_ticket_receipts[0].invoice}
              </Text>
            </Col>
            <Col span={12}>
              <Text colon strong title="web.receipt.form.justification.title">
                {receipt.request_ticket_receipts[0].justification}
              </Text>
            </Col>
          </WrapRow>
          <Divider />
          <ThumbnailList
            images={
              receipt.request_ticket_receipts[0].request_ticket_receipt_images
            }
          />
        </>
      )}
    </Modal>
  )
}

export default ModalVisualization
